import React from 'react';
import Transporte from '../paquetes-detalle/detalle-eurovips/paquete-detalle-transporte/paquete-detalle-transporte';
import PanelBasico from '../paquetes-detalle/panel-basico/panel-basico';
// import Servicios from "../paquetes-detalle/detalle-eurovips/servicios-incluidos/servicios-incluidos";
import Hoteles from '../paquetes-detalle/detalle-eurovips/paquete-detalle-hoteles/paquete-detalle-hoteles';
import './detalle.css';

const DetalleEurovips = (props) => {
  return (
    <span className='confirmacion-pago'>
      <Transporte
        transporte={props.paquete.salidas[0].transporte}
        ida={props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeIda}
        vuelta={props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeVuelta}
      />
      {/*<Servicios*/}
      {/*descripcion={props.paquete.salidas[0].servicios}*/}
      {/*iconos={props.paquete.salidas[0].tipoServicios}*/}
      {/*/>*/}
      <Hoteles
        destinos={props.paquete.salidas[0].destinosHoteles}
        hoteles={props.paquete.salidas[0].hoteles}
      />
      <PanelBasico
        titulo='Observaciones'
        contenido={props.paquete.salidas[0].observaciones[0]}
      />
      <PanelBasico
        titulo='No incluye'
        contenido={props.paquete.salidas[0].noIncluye}
      />
      <PanelBasico
        titulo='Política de cancelación'
        contenido={props.paquete.politicaCancelacion[0].descripcion}
      />
    </span>
  );
};

export default DetalleEurovips;
